export default "__VITE_ASSET__832d1cb7__"